import React, { memo } from '../../lib/teact/teact';

import type { ApiWalletTransactionCounterparty } from '../../api/types';

import buildClassName from '../../util/buildClassName';

import useLang from '../../hooks/useLang';

import Button from '../ui/Button';
import InteractiveTextField from '../ui/InteractiveTextField';
import Modal from '../ui/Modal';
import CounterpartyAvatar from './CounterpartyAvatar';

import modalStyles from '../ui/Modal.module.scss';
import styles from './CounterpartyDetailsModal.module.scss';

interface Props {
  counterparty: ApiWalletTransactionCounterparty;
  isOpen: boolean;
  onClose: NoneToVoidFunction;
  onEdit?: NoneToVoidFunction;
}

function CounterpartyDetailsModal({ counterparty, isOpen, onClose, onEdit }: Props) {
  const lang = useLang();
  const addresses = [...new Set(counterparty.addresses ?? [])];

  return (
    <Modal isOpen={isOpen} isCompact hasCloseButton title={lang('Counterparty')} onClose={onClose}>
      <div data-telemetry-block="">
        <div className={styles.identity}>
          <CounterpartyAvatar counterparty={counterparty} size="large" />
          <h3 className={styles.name}>{counterparty.name}</h3>
        </div>
        <div className={styles.label}>{lang('Addresses')}</div>
        <div className={styles.addresses}>
          {addresses.length ? addresses.map((address) => (
            <div key={address} className={styles.address}>
              <InteractiveTextField
                className={styles.addressText}
                address={address}
                chain="tron"
                forceFullAddress
                noSavedAddress
                noExplorer
              />
            </div>
          )) : <div className={styles.address}>{lang('$metadata_no_addresses')}</div>}
        </div>
        {onEdit && (
          <div className={buildClassName(modalStyles.buttons, styles.actions)}>
            <Button isSecondary className={styles.editButton} onClick={onEdit}>
              <i className="icon-pen" aria-hidden />{lang('Edit')}
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default memo(CounterpartyDetailsModal);
